<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/13LxQTK/tc-custom/9781636980959.jpg?1737334543277" alt="This image is the cover for the book indomitable"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">indomitable
      </h1>
      <p class="bookDescription body article font2">
        <p>From childhood to motherhood, Di Ciruolo takes readers through very personal and intensely heartbreaking experiences and creates a safe space for trauma survivors with indomitable.</p><p>Indomitable is a true story of foster care survival. With intentional wit and a healthy amount of self-reflection, Di Ciruolo invites explorers to find the places they can relate to while finding footing on the rungs to healing. Ciruolo shines a light on inner trauma, by offering encouragement and guidance for survivors and those who seek to support them. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Di  Ciruolo
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Morgan James Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7391bb90